import {
  applySnapshot,
  Instance,
  SnapshotIn,
  SnapshotOut,
  flow,
  types,
} from 'mobx-state-tree';

import { utils, storage } from 'lib';

const initState = {
  allList: [],
  giftList: [],
  chatList: [],
  control: {
    allList: {},
    giftList: {},
    chatList: {},
  },
  userList: [
    {
      _id: 0,
      nick_name: '所有人',
    },
  ],
  currentUser: 0,
  enableOtherTab: true,
};

const MsgModel = types
  .model({
    id: types.string,
    time: '',
    tabType: types.maybeNull(
      types.enumeration('MsgTabType', ['all', 'chat', 'gift']),
    ),
    msgType: '',
  })
  .volatile((self) => ({
    msg: {},
    render: null,
  }))
  .actions((self) => {
    const setMsg = (msg) => {
      self.msg = msg;
    };
    const setRender = (render) => {
      self.render = render;
    };
    return {
      setMsg,
      setRender,
    };
  });

// const MsgListModel = type
//   .model('MsgListModel',{
//     list:types.array(MsgModel)
//   })

const maxLen = 50;

const UserModel = types.model('MessageUserModel', {
  _id: types.identifierNumber,
  pic: '',
  nick_name: '',
});

const ControlModel = types
  .model('ControlModel', {
    enableScroll: true,
    scrollIndex: 0,
  })
  .actions((self) => {
    const toggleEnable = () => {
      self.enableScroll = !self.enableScroll;
    };
    const increaseScrollIndex = () => {
      if (self.enableScroll) {
        self.scrollIndex++;
      }
    };
    return {
      toggleEnable,
      increaseScrollIndex,
    };
  });

export const Model = types
  .model('MessagesModel', {
    allList: types.array(MsgModel),
    giftList: types.array(MsgModel),
    chatList: types.array(MsgModel),
    userList: types.array(UserModel),
    control: types.model({
      allList: ControlModel,
      giftList: ControlModel,
      chatList: ControlModel,
    }),
    currentUser: types.reference(UserModel),
    enableOtherTab: false,
    filter: types.optional(
      types.model({
        chat: true, // 为true显示
        chatToMe: true,
        gift: true, // _msg_gift
        broadcast: true,
      }),
      {},
    ),
  })
  .actions((self) => {
    /**
     *
     * @param msg
     * {
     *   tabType,  同步到 chat/gift tab下
     *   msgType,
     *   render   msgType、render 二选一即可
     *   msg,
     * }
     */
    const add = (msg) => {
      msg.id = utils.getRandomString(4);
      msg.time = utils.formatTime(Date.now(), 'hh:mm');

      if (msg.tabType === 'chat' && self.enableOtherTab) {
        let chatModel = MsgModel.create(msg);
        chatModel.setMsg(msg.msg);
        if (
          self.chatList.length > maxLen &&
          self.control.chatList.enableScroll
        ) {
          self.chatList.splice(0, self.chatList.length - maxLen);
        }
        self.chatList.push(chatModel);
        self.control.chatList.increaseScrollIndex();
      }
      if (msg.tabType === 'gift' && self.enableOtherTab) {
        let giftModel = MsgModel.create(msg);
        giftModel.setMsg(msg.msg);
        if (
          self.giftList.length > maxLen &&
          self.control.giftList.enableScroll
        ) {
          self.giftList.splice(0, self.giftList.length - maxLen);
        }
        self.giftList.push(giftModel);
        self.control.giftList.increaseScrollIndex();
      }
      let model = MsgModel.create(msg);
      model.setMsg(msg.msg);
      model.setRender(msg.render);

      if (self.allList.length > maxLen && self.control.allList.enableScroll) {
        self.allList.splice(0, self.allList.length - maxLen);
      }
      self.allList.push(model);
      self.control.allList.increaseScrollIndex();
    };

    const chatAt = (userInfo) => {
      if (!self.userList.find((item) => item._id === userInfo._id)) {
        self.userList.push(userInfo);
      }
      self.currentUser = userInfo._id;
    };
    const setCurrentUser = (uid) => {
      self.currentUser = uid;
    };

    const clearAllList = () => {
      self.allList.clear();
    };
    const clearChatList = () => {
      self.chatList.clear();
    };
    const clearGiftList = () => {
      self.giftList.clear();
    };

    const setEnableOtherTab = (status) => {
      self.enableOtherTab = status;
    };

    const setFilter = (type, status) => {
      self.filter[type] = status;
      // storage.setItem('MSG_FILTER',JSON.stringify(self.filter.toJSON()))
    };

    // const initFilter = () => {
    //   self.filter = storage.getItem('MSG_FILTER')||{}
    // }

    return {
      add,
      chatAt,
      setCurrentUser,
      clearAllList,
      clearChatList,
      clearGiftList,
      setEnableOtherTab,
      setFilter,
    };
  });

export default {
  initState,
  Model,
};
